export const getOS = () => {
  const userAgent = window.navigator.userAgent;
  const platform = window.navigator.platform;

  const macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"];
  const windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"];
  const iosPlatforms = ["iPhone", "iPad", "iPod"];

  let os = null;
  let transformedOs = null;

  if (platform === "MacIntel" && navigator.maxTouchPoints > 1) {
    os = "iOS";
  } else if (macosPlatforms.indexOf(platform) !== -1) {
    os = "MacOS";
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = "iOS";
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = "Windows";
  } else if (/Android/.test(userAgent)) {
    os = "Android";
  } else if (/Linux/.test(platform)) {
    os = "Linux";
  }

  if (
    /iPhone|iPad|iPod/.test(userAgent) ||
    (platform === "MacIntel" && navigator.maxTouchPoints > 1)
  ) {
    transformedOs = "iOS";
  } else if (/Android/.test(userAgent)) {
    transformedOs = "Android";
  }

  return { os, transformedOs };
};

export const isMobile = () => {
  const { os } = getOS();
  if (os) {
    return ["iOS", "Android"].includes(os);
  }
  return false;
};

export const isMobileView = () => {
  const { os, transformedOs } = getOS();
  console.log("os", { os, transformedOs });
  if (transformedOs) {
    return ["iOS", "Android"].includes(transformedOs);
  }
  return false;
};

export const getBrowser = () => {
  const ua = navigator.userAgent;

  if (/opera|opr/i.test(ua)) {
    return "Opera";
  } else if (/msie|trident/i.test(ua)) {
    return "Internet Explorer";
  } else if (/chrome.+? edge/i.test(ua)) {
    return "Microsoft Edge";
  } else if (/chrome|crios|crmo/i.test(ua)) {
    return "Google Chrome";
  } else if (/firefox/i.test(ua)) {
    return "Firefox";
  } else if (/safari/i.test(ua)) {
    return "Safari";
  }

  return "Unknown";
};
